function fromStringToBoolean(candidate: string | boolean): boolean {
	return typeof candidate === 'boolean'
		? candidate
		: Boolean(JSON.parse(candidate.toString()))
}

export {
	fromStringToBoolean,
};
